/*
 * @Author: your name
 * @Date: 2021-09-06 13:26:28
 * @LastEditTime: 2021-09-09 16:51:04
 * @LastEditors: lz
 * @Description: In User Settings Edit
 * @FilePath: \fe-crworkbench-web\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import antdPlugin from '@/plugins/antd'
Vue.use(antdPlugin) // antd 组件
import myComponentsInstall from '@/components/myComponentsInstall'
Vue.use(myComponentsInstall)
import directives from '@/plugins/directive' //全局指令
directives(Vue)
import '@/assets/less/style.less' // 全局样式
import '@/assets/icons/index' // Svgicon

import './permission' //路由拦截
Vue.config.productionTip = false

console.log(process.env.VUE_APP_BASE_URL)
console.log('当前发布环境', process.env.VUE_APP_ENV)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
